import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { faPrint } from '@fortawesome/pro-regular-svg-icons';
import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import FilterSelect from '../../../../components/FilterSelect';
import LoadingApp from '../../../../components/LoadingApp';
import ModalFeedBack from '../../../../components/ModalFeedBack';
import { FilterInterface } from '../../../../interfaces/entities/FilterInterface';
import { BeneficiarioUtilizacaoServico } from '../../../../interfaces/entities/UtilizacaoServicos/BeneficiarioUtilizacaoServico';
import { getExtratoUtilizacao, getPeriodoExtratoUtilizacao } from '../../../../services/BeneficiarioService';
import { getUtilizacaoServico } from '../../../../services/ContratoService';
import { base64toBlob } from '../../../../utils/Base64ToBlob';
import { sxButtonConsultar, sxButtonText, sxButtonTextPrint, sxTypographyAdvice, sxValidationMessage } from '../sxProps';
import BeneficiaryData from './BenefData';
import GrupoDetalheUtilizacaoData from './GrupoDetalheUtilizacaoData';
import '../styles.css'
import { useAccessibility } from '../../../../Store/contexts/AccessibilityContext';
import PageTitle from '../../../../components/Accessibility/PageTitle';
import { mapMonthAbrevToFull } from '../../../../utils/MonthMap';

const UtilizacaoDosServicos = () => {
  const navigate = useNavigate();

  const accessibility = useAccessibility();

  const [loading, setLoading] = useState<boolean>(false);
  const [getExec, setGetExec] = useState<boolean>(false);
  const [periodos, setPeriodos] = useState<FilterInterface[]>([]);
  const [periodoSelecionado, setPeriodoSelecionado] = useState<string>('');
  const [beneficiarioUtilizacaoServico, setBeneficiarioUtilizacaoServico] = useState<Array<BeneficiarioUtilizacaoServico>>([]);
  const [modalFeedback, setModalFeedback] = useState<null | {
    icon?: 'error' | 'success' | 'warning', title?: string, textButton?: string, subTitle?: string,
    closeAction: () => void, showButtonModal: boolean, buttonAction?: () => void
  }>(null);

  useEffect(() => {
    loadPeriodo();
  }, []);

  const loadPeriodo = () => {
    setLoading(true);
    getPeriodoExtratoUtilizacao()
      .then(response => {
        if (response?.data) {
          const periodos = response.data.map((periodo: { valor: any; descr: any; }) => {
            const [monthAbrev, year] = periodo.descr.split('/');
            const fullMonth = mapMonthAbrevToFull(monthAbrev);
            return {
              id: periodo.valor,
              descricao: periodo.descr,
              ariaDescricao: `${fullMonth} de ${year}`,
            };
          });
          
          setPeriodos(periodos);
          setLoading(false);
        }
      })
      .catch((response) => {
        const message = response?.error?.message;
        openModalError('Erro ao buscar extrato', message ? message : 'Não foi possível buscar o período')
        setLoading(false);
      });
  }

  const getExtrato = () => {
    setLoading(true);
    getUtilizacaoServico(periodoSelecionado)
      .then(response => {
        if (response?.data) {
          setBeneficiarioUtilizacaoServico(response?.data);
        }
      })
      .catch(response => {
        const message = response?.data?.mensagem;
        openModalError('Erro ao buscar extrato', message ? message : '')
      })
      .finally(() => {
        setLoading(false);
        setGetExec(true);
      })
  }

  const printExtrato = () => {
    setLoading(true);
    getExtratoUtilizacao(periodoSelecionado)
      .then(response => {
        if (response?.data) {
          const pdf = response.data;
          const blob = base64toBlob(pdf.split(',')[1]);
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl);
        }
      })
      .catch(response => {
        const message = response?.data?.mensagem;
        openModalError('Erro ao buscar utilização', message ? message : '')
      })
      .finally(() => {
        setLoading(false);
      })
  }

  const openModalError = (title: string, subtitle: string) => {
    setModalFeedback({
      icon: 'error',
      title: title,
      subTitle: subtitle,
      textButton: 'Fechar',
      showButtonModal: true,
      closeAction: () => setModalFeedback(null),
      buttonAction: () => setModalFeedback(null)
    });
  }

  return (
    <div className='container-info-plan '>
      <PageTitle text="Utilização dos serviços" marginBottom="8px" />
      <div className='advice-container-service-plan' style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility}}>
        <div className='advice-text' >
          <Typography style={accessibility.textStyleAccessibility} sx={sxTypographyAdvice}>
            <strong className='important-bold'>IMPORTANTE:</strong>  As informações apresentadas no relatório não são para fins de dedução no Imposto de Renda, são apenas para detalhamento da sua utilização.
          </Typography>
        </div>
      </div>
      <div>
        <div className="filter-row">
          <div className="filter-option-service-plan">
            <FilterSelect title='Mês/Ano' options={periodos} disabled={false} handleChange={setPeriodoSelecionado} />
          </div>
          <div className={'align-bottom'}>
            <Button disabled={periodoSelecionado === ''} variant='contained' style={accessibility.buttonStyleAccessibility} sx={sxButtonConsultar} onClick={() => { getExtrato() }}>
              <Typography style={accessibility.buttonTextStyleAccessibility}>Consultar</Typography>
            </Button>
          </div>
        </div>
        {getExec && beneficiarioUtilizacaoServico.length === 0 &&
          <div className='container-validation-message'>
            <FontAwesomeIcon icon={faCircleExclamation} size='sm' color='#D84141' />
            <Typography style={accessibility.textStyleAccessibility} id='errUserName' sx={sxValidationMessage}>Nenhum item encontrado.</Typography>
          </div>}
      </div>
      {beneficiarioUtilizacaoServico.length > 0 &&
        <div className='width-100'>
          <BeneficiaryData beneficiario={beneficiarioUtilizacaoServico[0]} />

          {beneficiarioUtilizacaoServico[0].lstDetails.map(group =>
            <div key={group.groupText} className='container-grupo-service'>
              <span style={accessibility.textStyleAccessibility} className='filter-title-service-plan'>{group.groupText}</span>
              <div className='container-grupo-detail-service'>
                {group.lstDetails.map(groupDetail =>
                  <div>
                    <GrupoDetalheUtilizacaoData GrupoDetalhe={groupDetail} Type={group.groupText} />
                  </div>
                )}
              </div>
            </div>
          )}

          <div className='container-button-print-servicos'>
            <Button
              onClick={() => printExtrato()}
              variant="text"
              startIcon={<FontAwesomeIcon icon={faPrint} />}
              disabled={!periodoSelecionado}
            >
              <Typography style={accessibility.textStyleAccessibility} sx={sxButtonTextPrint}>Imprimir utilização</Typography>
            </Button>
          </div>
        </div>
      }
      <div className='container-button-back-servicos'>
        <Button
          onClick={() => navigate(-1)}
          startIcon={<FontAwesomeIcon style={accessibility.textStyleAccessibility} icon={faChevronLeft} color="#383838" />}
        >
          <Typography style={{...accessibility.textStyleAccessibility}} sx={sxButtonText}>Voltar</Typography>
        </Button>
      </div>
      <LoadingApp showLoading={loading} />
      <ModalFeedBack
        showModal={!!modalFeedback}
        icon={modalFeedback?.icon as 'success' | 'error'}
        textButton={modalFeedback?.textButton as string}
        title={modalFeedback?.title as string}
        subTitle={modalFeedback?.subTitle as string}
        showButtonModal={modalFeedback?.showButtonModal}
        handleShowModal={modalFeedback?.closeAction}
        handleButtonModal={modalFeedback?.buttonAction}
      />
    </div>
  )
}

export default UtilizacaoDosServicos